import { useFetch } from '../../hooks/useFetch';

/**
 * @param {import('../../types/dashboard').DashboardRefreshParams} [params]
 * @returns {Promise<import('../../types/dashboard').DashboardRecent>}
 */
export const FetchDashboardRecent = async (params) => {
  const body = await useFetch('/dashboard/recent', params);

  return body.data;
};
